module.exports = __webpack_public_path__ + "img/icon (4).9bd56136.png";